import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const update_user_auth = async (user_auth) => {
  try {
    const data = {
      name: user_auth?.name,
      area: user_auth?.area,
      city : user_auth?.city,
      country: user_auth?.country,
      state: user_auth?.state,
      phone:user_auth?.phone
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-user-auth`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export { update_user_auth };
